//@ts-nocheck
import Axios from 'axios';
import setAuthToken from 'services/utils/setAuthToken';
import FileSaver from 'file-saver';

export const createStorageItem = async (data) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const response = await Axios.post('/api/storage/items', data);
    return response.data;
  } catch (error) {
    console.error('Error creating storage item:', error);
    throw error;
  }
};

export const getStorageItems = async () => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const response = await Axios.get('/api/storage/items');
    return response.data;
  } catch (error) {
    console.error('Error getting storage items:', error);
    throw error;
  }
};

export const updateStorageItem = async (id, data) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const response = await Axios.put(`/api/storage/items/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating storage item:', error);
    throw error;
  }
};

export const deleteStorageItem = async (id) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const response = await Axios.delete(`/api/storage/items/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting storage item:', error);
    throw error;
  }
};

// Storage Orders API
export const createStorageOrder = async (data) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const response = await Axios.post('/api/storage/orders', data);
    return response.data;
  } catch (error) {
    console.error('Error creating storage order:', error);
    throw error;
  }
};

export const getStorageOrders = async (filters = {}) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const queryParams = new URLSearchParams();

    // Dodaj filtry, ignorując puste wartości
    Object.keys(filters).forEach((key) => {
      if (
        filters[key] !== undefined &&
        filters[key] !== null &&
        filters[key] !== ''
      ) {
        queryParams.append(key, filters[key]);
      }
    });

    const url = queryParams.toString()
      ? `/api/storage/orders?${queryParams.toString()}`
      : '/api/storage/orders';
    const response = await Axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error getting storage orders:', error);
    throw error;
  }
};

export const getStorageOrderById = async (id) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const response = await Axios.get(`/api/storage/orders/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error getting storage order:', error);
    throw error;
  }
};

export const updateStorageOrder = async (id, data) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const response = await Axios.put(`/api/storage/orders/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating storage order:', error);
    throw error;
  }
};

export const completeStorageOrder = async (id) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const response = await Axios.put(`/api/storage/orders/${id}/complete`);
    return response.data;
  } catch (error) {
    console.error('Error completing storage order:', error);
    throw error;
  }
};

export const sendStorageOrder = async (id) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const response = await Axios.put(`/api/storage/orders/${id}/send`);
    return response.data;
  } catch (error) {
    console.error('Error sending storage order:', error);
    throw error;
  }
};

export const deleteStorageOrder = async (id) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const response = await Axios.delete(`/api/storage/orders/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting storage order:', error);
    throw error;
  }
};

export const downloadStorageOrderPdf = async (id, number) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const res = await Axios.get(`/api/storage/orders/${id}/items-list`, {
      responseType: 'arraybuffer',
    });

    FileSaver.saveAs(
      new Blob([res.data], { type: 'application/pdf;charset=utf-8' }),
      `Zamówienie magazynowe - ${number}.pdf`,
    );

    return res.data;
  } catch (error) {
    console.error('Error downloading storage order PDF:', error);
    throw error;
  }
};

export const receiveStorageOrder = async (id, receiveData) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const response = await Axios.put(
      `/api/storage/orders/${id}/receive`,
      receiveData,
    );
    return response.data;
  } catch (error) {
    console.error('Error receiving storage order:', error);
    throw error;
  }
};

// Update Storage Quantity
export const updateStorageQuantity = async (data) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const response = await Axios.post(
      '/api/storage/update-quantity',
      data,
    );
    return response.data;
  } catch (error) {
    console.error('Error updating storage quantity:', error);
    throw error;
  }
};

// Storage History API
export const getStorageHistory = async (filters = {}) => {
  if (localStorage.token) setAuthToken(localStorage.token);

  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams
      ? `/api/storage/history?${queryParams}`
      : '/api/storage/history';
    const response = await Axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error getting storage history:', error);
    throw error;
  }
};
